import PropTypes from 'prop-types';
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { layoutTypes } from "./constants/layout";
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes";

// Import all middleware
import Authmiddleware from "./routes/route";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";

// 1. Fake Backend'i KAPATIN (Yorum satırına alın veya silin)
// import fakeBackend from "./helpers/AuthType/fakeBackend";

import { initFirebaseBackend } from 'helpers/firebase_helper';

// 2. Fake Backend Aktivasyonunu da KAPATIN
// fakeBackend();

// 3. Firebase Config ve Başlatma (Burası Kalacak)
const firebaseConfig = {
  apiKey: "AIzaSyDwCKg07bED8vhQT5lS-k2AnvQc776kVaI",
  authDomain: "subseaw-57ad9.firebaseapp.com",
  projectId: "subseaw-57ad9",
  storageBucket: "subseaw-57ad9.firebasestorage.app",
  messagingSenderId: "904655820386",
  appId: "1:904655820386:web:22159cd56618a86f4e633b",
  measurementId: "G-3YYTH0MH2R"
};

initFirebaseBackend(firebaseConfig);

const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const App = () => {
  const [loading, setLoading] = useState(true);
  const spinner = document.getElementById("spinner");
  if (spinner) {
    setTimeout(() => {
      spinner.style.display = "none";
      setLoading(false);
    }, 500);
  }

  const { layoutType } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
  }));

  const Layout = getLayout(layoutType);

  return (
    !loading && (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <NonAuthLayout>
                {route.component}
              </NonAuthLayout>
            }
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware>
                <Layout>{route.component}</Layout>
              </Authmiddleware>}
            key={idx}
            exact={true}
          />
        ))}
      </Routes>
    </React.Fragment>
    )
  );
};

App.propTypes = {
  layout: PropTypes.any
};

export default App;